import { PagerDutyService } from '../models/pagerDutyService.model';

export const MOCK_PAGER_DUTY_SERVICES: PagerDutyService[] = [
    {
        contactEmail: 'unai.manzanoperez.ext@allianz-trade.com',
        serviceIntegrationManagementServiceOffering: 'Mock data',
        pagerDutyTeamId: 'Mock data',
        serviceIntegrationManagementAssignmentGroup: 'Mock data',
        jiraProjectId: 'Mock data',
        serviceIntegrationManagementBusinessService: 'Mock data',
        pagerDutyServiceName: '[GSA] Example Api',
        pagerDutyServiceId: 'PBHRXWN',
        emailDistributionList: [
            'unai.manzanoperez.ext@allianz-trade.com',
            'test.manzanoperez.ext@allianz-trade.com',
        ],
        applications: []
    },
    {
        contactEmail: 'unai.manzanoperez.ext@allianz-trade.com',
        serviceIntegrationManagementServiceOffering: 'Mock data 2',
        pagerDutyTeamId: 'Mock data 2',
        serviceIntegrationManagementAssignmentGroup: 'Mock data 2',
        jiraProjectId: 'Mock data 2',
        serviceIntegrationManagementBusinessService: 'Mock data 2',
        pagerDutyServiceName: '[GSA] Example Api 2',
        pagerDutyServiceId: 'ABCD1234',
        emailDistributionList: [
            'unai.manzanoperez.ext@allianz-trade.com',
            'test.manzanoperez.ext@allianz-trade.com',
        ],
        applications: []
    },
    {
        contactEmail: 'unai.manzanoperez.ext@allianz-trade.com',
        serviceIntegrationManagementServiceOffering: 'Mock data 2',
        pagerDutyTeamId: 'Mock data 2',
        serviceIntegrationManagementAssignmentGroup: 'Mock data 2',
        jiraProjectId: 'Mock data 2',
        serviceIntegrationManagementBusinessService: 'Mock data 2',
        pagerDutyServiceName: '[GSA] Example Api 2',
        pagerDutyServiceId: 'PXYZ123',
        emailDistributionList: [
            'unai.manzanoperez.ext@allianz-trade.com',
            'test.manzanoperez.ext@allianz-trade.com',
        ],
        applications: []
    },
    {
        contactEmail: 'unai.manzanoperez.ext@allianz-trade.com',
        serviceIntegrationManagementServiceOffering: 'Mock data 2',
        pagerDutyTeamId: 'Mock data 2',
        serviceIntegrationManagementAssignmentGroup: 'Mock data 2',
        jiraProjectId: 'Mock data 2',
        serviceIntegrationManagementBusinessService: 'Mock data 2',
        pagerDutyServiceName: '[GSA] Example Api 2',
        pagerDutyServiceId: 'PB9SE6X',
        emailDistributionList: [
            'unai.manzanoperez.ext@allianz-trade.com',
            'test.manzanoperez.ext@allianz-trade.com',
        ],
        applications: []
    }
]
